module.exports = __webpack_public_path__ + "static/media/G2.40943982.png";